<div class="host-container">
  <div class="content">
    <intake-header></intake-header>
    <social-intake-form (formStateChange)="currentFormState = $event"></social-intake-form>
    <intake-footer *ngIf="currentFormState === socialIntakeFormState.FORM"></intake-footer>
  </div>
</div>
